import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import App from 'browser/App';
import GlobalStyle from 'browser/styled/GlobalStyle';
import investment from 'browser/investments/wyspa-solna';
import getFlatsWithProperties from 'browser/utils/getFlatsWithProperties';
import axios from 'axios';
import { useResizeDetector } from 'react-resize-detector/build/withPolyfill';
import isLocalStorageAvailable from './utils/isLocalStorageAvailable';

const BrowserWrapper = ({ allFlats, loading, loadingText, ...props }) => {
  const [isLoading, setIsLoading] = useState(loading);
  const [flats, setFlats] = useState(getFlatsWithProperties(allFlats));
  const { height, ref } = useResizeDetector();

  useEffect(() => {
    if (!allFlats) {
      const GetData = async () => {
        const savedFlats = undefined;
        // = JSON.parse(
        //   isLocalStorageAvailable() &&
        //     sessionStorage.getItem(`flats1.${investment.investmentName}`)
        // );

        if (savedFlats && savedFlats.length) {
          setFlats(savedFlats);
          setIsLoading(false);
        } else {
          try {
            setIsLoading(true);
            const { data } = await axios.get(investment.flatsURL);
            const formatedFlats = getFlatsWithProperties(
              data.filter(el =>
                [`wyspa-solna-ab`, `wyspa-solna-e`].includes(el.investment_slug)
              )
            );

            setFlats(formatedFlats);
            setIsLoading(false);
            if (isLocalStorageAvailable()) {
              sessionStorage.setItem(
                `flats.${investment.investmentName}`,
                JSON.stringify(formatedFlats)
              );
            }
          } catch (err) {
            console.log(err);
          }
        }
      };

      GetData();
    }
  }, [allFlats]);

  useEffect(() => {
    window.top.postMessage(`CONTENT_HEIGHT/${Math.ceil(height)}`, '*');
  }, [height]);

  useEffect(() => {
    window.top.postMessage(`IFRAME_LOADED`, '*');
    document.documentElement.style.setProperty('--vh', `100vh`);
  }, []);

  return (
    <div id="browser" ref={ref}>
      <GlobalStyle />
      <App
        allFlats={flats}
        investment={investment}
        isLoading={isLoading}
        loadingText={loadingText}
        {...props}
      />
    </div>
  );
};

BrowserWrapper.propTypes = {
  allFlats: PropTypes.arrayOf(PropTypes.object),
  loadingText: PropTypes.string,
  loading: PropTypes.bool,
};

BrowserWrapper.defaultProps = {
  allFlats: null,
  loadingText: `Ładowanie mieszkań`,
  loading: true,
};

export default BrowserWrapper;
